define('adminEmailAddressesListRowToolsView',[
  'module',
  'tableFieldView',
  'template!adminEmailAddressesListRowToolsView'
], function (
  Module,
  FieldView,
  Tpl
) {
  'use strict';

  // Empty row-tools cell. Rows are clicked directly to open the popup.
  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-email-addresses-list-row-tools-view table-field-view'
  });
});

